// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .SubnavBar-progressContainer-Y10KM {
 	width: 100%;
 	background-color: var(--common-text-color);
 	position: relative;
 }

 .SubnavBar-navList-YoW7c {
 	list-style: none;
 	max-width: 1080px;
 	margin: 0 auto;
 	padding: 15px 15px;
 	display: -webkit-box;
 	display: -ms-flexbox;
 	display: flex;
 	overflow-x: auto;
 	overflow-y: hidden;
 	white-space: nowrap;
 }

 .SubnavBar-navList-YoW7c::-webkit-scrollbar {
 	display: none;
 }

 .SubnavBar-navItem-xzJqJ {
 	position: relative;
 	padding: 0px;
 	margin-right: 54px;
 	font-size: 16px !important;
 	color: var(--subNavbar-text-color);
 }

 .SubnavBar-active-lD_o2 .SubnavBar-navItem-xzJqJ,
 .SubnavBar-navItem-xzJqJ:hover {
 	color: var(--white-text);
 	text-decoration: none;
 	cursor: pointer;
 }

 .SubnavBar-active-lD_o2 .SubnavBar-navItem-xzJqJ,
 .SubnavBar-navItem-xzJqJ:focus {
 	color: var(--white-text);
 	text-decoration: none;
 	cursor: pointer;
 }

 .SubnavBar-active-lD_o2 .SubnavBar-navItem-xzJqJ::after {
 	content: '';
 	position: absolute;
 	top: 35px;
 	left: 0;
 	right: 0;
 	height: 3px;
 	background: var(--primary-white-bg);
 }`, "",{"version":3,"sources":["webpack://./src/components/SubnavBar/SubnavBar.css"],"names":[],"mappings":"CAAC;EACC,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,kCAAkC;CACnC;;CAEA;;EAEC,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;CAChB;;CAEA;;EAEC,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mCAAmC;CACpC","sourcesContent":[" .progressContainer {\n \twidth: 100%;\n \tbackground-color: var(--common-text-color);\n \tposition: relative;\n }\n\n .navList {\n \tlist-style: none;\n \tmax-width: 1080px;\n \tmargin: 0 auto;\n \tpadding: 15px 15px;\n \tdisplay: flex;\n \toverflow-x: auto;\n \toverflow-y: hidden;\n \twhite-space: nowrap;\n }\n\n .navList::-webkit-scrollbar {\n \tdisplay: none;\n }\n\n .navItem {\n \tposition: relative;\n \tpadding: 0px;\n \tmargin-right: 54px;\n \tfont-size: 16px !important;\n \tcolor: var(--subNavbar-text-color);\n }\n\n .active .navItem,\n .navItem:hover {\n \tcolor: var(--white-text);\n \ttext-decoration: none;\n \tcursor: pointer;\n }\n\n .active .navItem,\n .navItem:focus {\n \tcolor: var(--white-text);\n \ttext-decoration: none;\n \tcursor: pointer;\n }\n\n .active .navItem::after {\n \tcontent: '';\n \tposition: absolute;\n \ttop: 35px;\n \tleft: 0;\n \tright: 0;\n \theight: 3px;\n \tbackground: var(--primary-white-bg);\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressContainer": `SubnavBar-progressContainer-Y10KM`,
	"navList": `SubnavBar-navList-YoW7c`,
	"navItem": `SubnavBar-navItem-xzJqJ`,
	"active": `SubnavBar-active-lD_o2`
};
module.exports = ___CSS_LOADER_EXPORT___;
